var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMultiWorkspaces(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.583,
    height: 17,
    viewBox: "343.208 319 15.583 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "icons8-layers"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m358.349 331.095-1.311-.672a2602.638 2602.638 0 0 1-.673.344c-1.721.88-3.679 1.88-4.13 2.107a4.08 4.08 0 0 1-.096.048 2.774 2.774 0 0 1-2.282-.002 3.511 3.511 0 0 1-.086-.043c-.462-.232-2.673-1.361-4.479-2.285a2198.073 2198.073 0 0 1-.33-.17l-1.311.673a.706.706 0 0 0-.443.655c0 .295.18.547.437.654v.014l6.711 3.427.006-.003A1.4 1.4 0 0 0 351 336c.23 0 .445-.06.637-.158l.007.003 6.71-3.427v-.014a.709.709 0 0 0 .438-.654.706.706 0 0 0-.443-.655Z",
    fill: "#01023f",
    fillRule: "evenodd",
    "data-name": "Path 13445"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m358.349 326.845-1.311-.672a1248.698 1248.698 0 0 1-4.9 2.499 2.774 2.774 0 0 1-1.138.245 2.78 2.78 0 0 1-1.143-.247 3.511 3.511 0 0 1-.086-.043c-.49-.247-2.953-1.504-4.809-2.454l-1.311.672a.706.706 0 0 0-.443.655.709.709 0 0 0 .437.654v.014l6.711 3.427.006-.003a1.409 1.409 0 0 0 .595.157 1.326 1.326 0 0 0 .043.001 1.379 1.379 0 0 0 .555-.119 1.584 1.584 0 0 0 .082-.039l.007.003 6.71-3.427v-.014a.709.709 0 0 0 .438-.654.706.706 0 0 0-.443-.655Z",
    fill: "#01023f",
    fillRule: "evenodd",
    "data-name": "Path 13444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m358.349 322.596-6.7-3.439h-.013a1.412 1.412 0 0 0-.593-.156A1.319 1.319 0 0 0 351 319c-.23 0-.444.06-.636.157h-.013l-6.7 3.439a.706.706 0 0 0-.006 1.308v.014l6.711 3.427.006-.003a1.4 1.4 0 0 0 .638.158 1.379 1.379 0 0 0 .555-.119 1.584 1.584 0 0 0 .082-.039l.007.003 6.71-3.427v-.014a.709.709 0 0 0 .438-.654.706.706 0 0 0-.443-.655Z",
    fill: "#01023f",
    fillRule: "evenodd",
    "data-name": "Path 13443"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiWorkspaces);
export default __webpack_public_path__ + "static/media/multiWorkspaces.1640b18d5ec96690a0dc6b65eb246a24.svg";
export { ForwardRef as ReactComponent };